import React from "react";
import {
	BarChart,
	Bar,
	XAxis,
	YAxis,
	CartesianGrid,
	Tooltip,
	Legend,
	ResponsiveContainer,
} from "recharts";
import { IWeeklyOrdersData } from "../pages/Dashboard";

interface IData {
	day: string;
	dorezuar: number;
	kthyer: number;
}

interface ISuccessRateChart {
	data: IWeeklyOrdersData[];
	title: string;
	deliveredString: string;
	returnedString: string;
}

const SuccessRateChart = ({
	data,
	title,
	deliveredString,
	returnedString,
}: ISuccessRateChart) => {
	return (
		<div className="background-div" style={{ height: "400px" }}>
			<div
				style={{
					height: "100%",
					width: "100%",
					display: "flex",
					flexDirection: "column",
					justifyContent: "space-between",
					alignContent: "end",
				}}
			>
				{/* <h2>Shkalla e suksesit</h2> */}
				<div className="statisticFirst">
					<p className="statisticParagraph">
						<b>{title}</b>
					</p>
					<div className="statisticSecond">
						<p>
							<span className="text-[#4F16C2]">•</span>{" "}
							{deliveredString}
						</p>
						<p>
							<span className="text-[#FF2828]">•</span>{" "}
							{returnedString}
						</p>
					</div>
				</div>
				<ResponsiveContainer width="100%" height="80%">
					<BarChart data={data} barCategoryGap="20%">
						<CartesianGrid strokeDasharray="3 3" />
						<XAxis dataKey="day" />
						<YAxis />
						<Tooltip />
						{/* <Legend /> */}
						<Bar
							dataKey="dorezuar"
							name="Dorëzuar"
							fill="#4F16C2"
							radius={[7, 7, 0, 0]}
						/>
						<Bar
							dataKey="kthyer"
							name="Kthyer"
							fill="#CFBFEE"
							radius={[7, 7, 0, 0]}
						/>
					</BarChart>
				</ResponsiveContainer>
			</div>
		</div>
	);
};

export default SuccessRateChart;
